import { Routes, Route } from 'react-router-dom'

import HCAMCAPage from 'features/RegulatoryTools/HCAMCA'
import PHMSAPage from 'features/RegulatoryTools/PHMSA'

const RegulatoryTools = () => {
  return (
    <Routes>
      <Route path='hca-mca' element={<HCAMCAPage />} />
      <Route path='phmsa-export' element={<PHMSAPage />} />
      <Route path='*' element={<HCAMCAPage />} />
    </Routes>
  )
}

export default RegulatoryTools
